import React, { useContext } from "react";
import { Dialog, DialogTitle, DialogActions, Button, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { i18n } from "../../translate/i18n";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import * as XLSX from "xlsx";

const useStyles = makeStyles(() => ({
  multFieldLine: {
    display: "flex",
    marginTop: 8,
  },
  btns: {
    margin: 15,
  },
  label: {
    padding: 18,
    width: "100%",
    textTransform: "uppercase",
    display: "block",
    marginTop: 10,
    border: "solid 2px grey",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: 8,
  },
}));

const ContactImportWpModal = ({ isOpen, handleClose, selectedTags, hideNum, userProfile }) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const history = useHistory();

  const handleOnExportContacts = async (model = false) => {
    const allDatas = [];

    let i = 1;
    if (!model) {
      while (i !== 0) {
        const { data } = await fetchContactsPage(i, selectedTags);
        data.contacts.forEach((element) => {
          const tagsContact = element?.tags?.map((tag) => tag?.name).join(", ");
          const carteira = element?.contactWallets && element.contactWallets.length > 0
            ? element.contactWallets[0].wallet?.email
            : "";

          const contactWithTags = { ...element, tags: tagsContact, carteira };
          allDatas.push(contactWithTags);
        });

        const pages = data?.count / 20;
        i++;
        if (i > pages) {
          i = 0;
        }
      }
    } else {
      allDatas.push({
        name: "Nome Contato",
        number: "5599999999999",
        email: "email-contato@email.com",
        birthDate: "15-05-1990",
        tags: "tag1, tag2",
        carteira: "funcionario-empresa@email.com",
      });
    }

    const exportData = allDatas.map((e) => ({
      name: e.name,
      number: hideNum && userProfile === "user"
        ? (e.isGroup ? e.number : `${e.number.slice(0, -6)}**-**${e.number.slice(-2)}`)
        : e.number,
      email: e.email,
      birthDate: e.birthDate || "",
      tags: e.tags,
      carteira: e.carteira,
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(wb, ws, "Contatos");
    XLSX.writeFile(wb, "backup_contatos.xlsx");
  };

  const fetchContactsPage = async (pageNumber, contactTag) => {
    const { data } = await api.get("/contacts/", {
      params: {
        searchParam: "",
        pageNumber,
        contactTag: JSON.stringify(contactTag),
      },
    });
    return { data };
  };

  const handleImportContacts = async () => {
    history.push("/contacts/import");
  };

  return (
    <Dialog fullWidth open={isOpen} onClose={handleClose}>
      <DialogTitle>{i18n.t("Exportar / Importar contatos")}</DialogTitle>
      <div>
        <Box style={{ padding: "0px 10px 10px" }}>
          <Can
            role={user.profile}
            perform="contacts-page:deleteContact"
            yes={() => (
              <div className={classes.multFieldLine}>
                <Button
                  fullWidth
                  size="small"
                  color="primary"
                  variant="contained"
                  onClick={() => handleOnExportContacts(false)}
                >
                  {i18n.t("contactImportWpModal.title")}
                </Button>
              </div>
            )}
          />
          <div className={classes.multFieldLine}>
            <Button
              fullWidth
              size="small"
              color="primary"
              variant="contained"
              onClick={() => handleOnExportContacts(true)}
            >
              {i18n.t("contactImportWpModal.buttons.downloadModel")}
            </Button>
          </div>
          <div className={classes.multFieldLine}>
            <Button
              fullWidth
              size="small"
              color="primary"
              variant="contained"
              onClick={handleImportContacts}
            >
              {i18n.t("contactImportWpModal.buttons.import")}
            </Button>
          </div>
        </Box>
      </div>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {i18n.t("contactImportWpModal.buttons.closed")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactImportWpModal;
